import { FC } from "react";
import { Link } from "react-router-dom";
import { mobileLinksAndPages } from "../utils/ProfileMobileLinksAndPages";
import { siteRoutes } from "@/routes/siteRoutesList";
import i18next from "i18next";
import { Card } from "@radix-ui/themes";

export const ProfileTabsMobile: FC<{}> = () => {
  return mobileLinksAndPages.map((obj, index) => {
    const key = `${obj.tab}_${index}`;
    if (obj.hasFeature) {
      return (
        <Card asChild key={key}>
          <Link key={key} to={`${siteRoutes["profileTabAndSlug"]}${obj.slug}`}>
            {i18next.t(`profile.tabs.${obj.tab.toLocaleLowerCase()}`)}
          </Link>
        </Card>
      );
    }
  });
};
